import { useState } from "react";
import { apiRoleToAccountType, getAuthUser, getStoredAccountType } from "../auth";
import { HospitalActsPage } from "./HospitalActsPage";
import { HospitalMedicalActsPage } from "./HospitalMedicalActsPage";

export function HospitalActsPageRouter() {
  const [accountType] = useState(() => {
    const fromUser = getAuthUser()?.role;
    if (fromUser) return apiRoleToAccountType(fromUser);
    return getStoredAccountType();
  });

  if (accountType === "hospital") {
    return <HospitalMedicalActsPage />;
  }

  return <HospitalActsPage />;
}
